export default "__VITE_ASSET__Cs$G6vKK__"